import { FC, FormEvent, useState } from "react"
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { useSearchAutoHoaCustomersQuery } from "../customerApi";
import { useParams } from "react-router-dom";
import ModalButton from "../../../components/common/form/ModalButton";
import { FaPlus, FaTrash } from "react-icons/fa";
import CustomerAutoHoaFormField from "./modals/CustomerAutoHoaFormField";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { useDeleteAutoHoaByIdMutation } from "../../hoa/auto-hoa/autoHoa";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";


const CustomerAutoHoa: FC = () => {

    document.title = `Customer Auto Hoa`;

    const { customerId } = useParams();
    const [showAddModal, setShowAddModal] = useState(false);
    const [autoHoaId, setAutoHoaId] = useState("");
    const [deleteApi, { isLoading: deleteApiResponse }] = useDeleteAutoHoaByIdMutation();
    const [showUpdateModal, setShowUpdateModal] = useState(false);


    const handleDeleteSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (autoHoaId) {
            await handleRTKQuery(
                () => deleteApi(autoHoaId).unwrap(),
                (isSuccess: any) => {
                    if (isSuccess) setAutoHoaId("");
                }
            );
        }
    };
    const columns: DataTableColumn[] = [
        {
            label: "State", accessor: "county.state.stateName",
            cell: (props: any) => {
                if (hasPermission(["AUTOHOA-R"])) {
                    return <>
                        <a
                            onClick={() => {
                                setAutoHoaId(props.row.original.id);
                                setShowUpdateModal(true)
                            }}
                            className="text-highlight-4 cursor-pointer">{props.row.original.county !== null ? props.row.original.county.state.stateName : props.row.original.msa.state.stateName}</a>
                    </>
                } else {
                    return <>
                        <span>{props.row.original.county !== null ? props.row.original.county.state.stateName : props.row.original.msa.state.stateName}</span>
                    </>
                }
            },
        },
        {
            label: "County", accessor: "county.countyName",

        },
        {
            label: "Metro Area", accessor: "msa.name",
            cell: (props: any) => <span title={props.value}>{props.value}</span>
        },
        {
            label: "Product Type", accessor: "productType",
            cell: (props: any) => <span title={props.value}>{props.value}</span>
        },
        {
            label: hasPermission(["AUTOHOA-D"]) ? "Action" : <span/>, accessor: ' ', canSort: false,
            cell: (props: any) => (
                hasPermission(["AUTOHOA-D"]) && props.row.original.id && (
                    <div className="ml-4">
                        <ModalButton
                            triggerButton={
                                <FaTrash
                                    className="cursor-pointer text-surface-0 text-lg hover:text-highlight-7"
                                    title="Delete Auto Hoa"
                                />
                            }
                            onOpen={() => setAutoHoaId(props.row.original.id)}
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title="Delete Auto Hoa"
                                    bodyMessage="Are you sure you want to delete this Auto Hoa?"
                                    onSubmit={handleDeleteSubmit}
                                    isLoading={deleteApiResponse}
                                />
                            }
                        />
                    </div>
                )
            )
        }
    ]

    return (
        <div className="user-container px-5 py-5">
            {hasPermission(["AUTOHOA-D"]) &&
            <div className="flex justify-end">
                <ModalButton
                    triggerButton={
                        <div className="h-7 w-10 text-text-0 rounded-md bg-highlight-0 flex justify-center items-center cursor-pointer  absolute top-0 left-auto">
                            <FaPlus />
                        </div>
                    }
                    modal={
                        <CustomerAutoHoaFormField show={showAddModal} setShow={setShowAddModal}
                            formType="Add" />
                    }
                />
            </div>
            }

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchAutoHoaCustomersQuery,
                }}
                defaultSortOptions={{
                    accessor: "creationDate",
                    direction: "asc"
                }}
                defaultFilter={{ customer: customerId }}
                appendFilterToUrl={false}
                basePermission={"AUTOHOA"}

            />
            {showUpdateModal && (
                <CustomerAutoHoaFormField show={showUpdateModal} setShow={setShowUpdateModal}
                    formType="Update" autoHoaId={autoHoaId} />
            )}
        </div>
    )
}
export default CustomerAutoHoa
